var map = {
	"./account-statement.svg": 467883,
	"./audits.svg": 108010,
	"./bag-icon.svg": 573610,
	"./bar-report.svg": 693116,
	"./bars.svg": 430444,
	"./bookings.svg": 783502,
	"./business-inteligence.svg": 731394,
	"./business-intelligence-v2.svg": 105217,
	"./cargo-cart.svg": 824329,
	"./cash-flow.svg": 362604,
	"./cdp.svg": 650745,
	"./change-language.svg": 609129,
	"./chart-of-accounts-v2.svg": 434958,
	"./chart-of-accounts.svg": 780705,
	"./clients.svg": 483894,
	"./communication.svg": 141530,
	"./config-adm.svg": 694943,
	"./contract.svg": 288236,
	"./crm.svg": 672594,
	"./customers.svg": 234093,
	"./dashboard-chart.svg": 522333,
	"./delivery-person-white.svg": 774572,
	"./delivery.svg": 1018,
	"./devices.svg": 728211,
	"./employee.svg": 238566,
	"./events.svg": 90825,
	"./file-check.svg": 169483,
	"./financial-report.svg": 254522,
	"./financial.svg": 454851,
	"./fiscal.svg": 672476,
	"./giftback.svg": 585189,
	"./help.svg": 291723,
	"./kds.svg": 36338,
	"./list-multiple.svg": 72939,
	"./logout.svg": 968072,
	"./loyalty.svg": 457580,
	"./megaphone.svg": 361140,
	"./multivendor-v2.svg": 328128,
	"./multivendor.svg": 175639,
	"./new-storage.svg": 557988,
	"./operation.svg": 819777,
	"./packages.svg": 341461,
	"./panel.svg": 291756,
	"./password-card.svg": 382800,
	"./pdv-status.svg": 351831,
	"./place.svg": 825835,
	"./pos-machine.svg": 899048,
	"./pre-charge.svg": 719706,
	"./products.svg": 557822,
	"./promotions.svg": 587308,
	"./receptive.svg": 131005,
	"./recharge-management.svg": 28011,
	"./report.svg": 712604,
	"./reports.svg": 483959,
	"./reserve.svg": 820046,
	"./satisfaction-survey.svg": 192309,
	"./sell-with-no-card.svg": 725644,
	"./settings.svg": 700697,
	"./stock-inventory.svg": 323947,
	"./storage-reports.svg": 79915,
	"./table-config.svg": 511357,
	"./table-report.svg": 984209,
	"./tax-data.svg": 829586,
	"./tax.svg": 665357,
	"./team.svg": 440949,
	"./tickets-report.svg": 532376,
	"./tickets-v2.svg": 368550,
	"./tickets.svg": 484121,
	"./users.svg": 920658,
	"./whats-up.svg": 813167,
	"./wizard.svg": 470563,
	"./zig-account.svg": 928758,
	"./zig-tag.svg": 225279
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 508229;
module.exports = webpackAsyncContext;